import React from "react";
import pluralize from "pluralize";

import close from "./../../../UI/general/close.svg";
//import gallery_i from "./../../../UI/Modal/gallery.svg";

interface Props {
  showTooltip: boolean;
  propertiesData: any;
  filteredProperty: any;
  clientX: any;
  clientY: any;
  handleHideTooltip: any;
  handleamenitiesMenySelection: any;
  tooltipIsRigth: any;
  spinsData: any;
  handleOpenPropertiesSpin: any;
  handleSetPropertyInQuotation: any;
  handleRemovePropertyInQuotation: any;
  quotationProperties: any;
  colors: any;
  isQuotation: any;
}

interface State {
  filter: any;
  attributesValues: any;
  spinOpened: boolean;
  spinData: any;
}

class PropertiesTooltip extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filter: {},
      attributesValues: {},
      spinOpened: false,
      spinData: [],
    };
  }

  componentDidMount(): void {
    var tempAttributesValuesArray: any = {};
    this.props.propertiesData.attributes.map(
      (attribute: any, index: number) =>
        (tempAttributesValuesArray[attribute.id] = {
          type: attribute.type,
          value: attribute.name,
          parent: attribute.padre,
        })
    );

    this.setState({
      attributesValues: tempAttributesValuesArray,
    });
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      prevProps.filteredProperty !== this.props.filteredProperty &&
      this.props.filteredProperty !== ""
    ) {
      var filter = this.props.propertiesData.property.filter(
        (property: any) => property.id === this.props.filteredProperty
      );
      this.setState({
        filter: filter[0],
      });
    }
  }

  handleGetTooltipWidth = () => {
    return 360;
  };

  render(): React.ReactNode {
    const factorEscala = window.innerWidth / 2100;

    return (
      <div
        className={
          this.props.showTooltip ? "tooltip fade-in" : "tooltip fade-out"
        }
        id="tooltip"
        /* style={{
          left: this.props.tooltipIsRigth
            ? this.props.clientX - this.handleGetTooltipWidth() + "px"
            : this.props.clientX + "px",
          top:
            this.props.clientY < window.innerHeight / 2
              ? this.props.clientY + "px"
              : this.props.clientY - 200 + "px",
        }} */

        style={{
          left:
            this.props.clientX * factorEscala + 360 > window.innerWidth
              ? this.props.clientX * factorEscala - 360 * factorEscala + "px"
              : this.props.clientX * factorEscala + 50 + "px",
          top:
            this.props.clientY < window.innerHeight / 2
              ? this.props.clientY + "px"
              : this.props.clientY - 200 + "px",
        }}
      >
        <div
          className="tooltip-close-container"
          onClick={() => {
            this.props.handleHideTooltip();
          }}
        >
          <img src={close} alt=""></img>
        </div>
        {this.state.filter ? (
          <div className="info-apto-container">
            <div className="property-name-tooltip">
              {this.state.filter.property}
            </div>
            <div className="hirarchical-tooltip-container">
              {this.state.filter.values
                ? this.state.filter.values.map(
                    (attribute: any, index: number) =>
                      this.state.attributesValues[attribute.attribute].type ===
                      "Hierarchical" ? (
                        <React.Fragment>
                          {this.state.attributesValues[attribute.attribute]
                            .parent === null ? (
                            <div key={attribute.value + "tooltip-apto" + index}>
                              {attribute.value}
                            </div>
                          ) : this.state.attributesValues[attribute.attribute]
                              .parent !== null ? (
                            <div key={attribute.value + "tooltip-apto" + index}>
                              {" / " + attribute.value}
                            </div>
                          ) : null}
                        </React.Fragment>
                      ) : null
                  )
                : null}
            </div>
            <hr></hr>
            <div style={{display: "flex"}}>
              <div>
                <img src="" alt="" />
              </div>
              <div className="attribute-values-tooltip">
                {this.state.filter.values
                  ? this.state.filter.values.map(
                      (attribute: any, index: number) =>
                        this.state.attributesValues[attribute.attribute]
                          .type !== "Hierarchical" ? (
                          <div key={attribute.value + "tooltip" + index}>
                            {pluralize.singular(
                              this.state.attributesValues[attribute.attribute]
                                .value
                            ) +
                              ": " +
                              attribute.value}
                          </div>
                        ) : null
                    )
                  : null}
              </div>
            </div>
            {(this.state.filter.galleries &&
              this.state.filter.galleries.length > 0) ||
            this.state.filter?.spins?.length > 0 ? (
              <hr></hr>
            ) : null}
            <div className="tooltip-galleries">
              <div style={{ display: "flex" }}>
                {this.state.filter?.spins?.length > 0 ? (
                  <div
                    className="tooltip-gallery-individual-item"
                    key={"tooltip-gallery-spin"}
                    onClick={() => {
                      this.setState(
                        {
                          spinOpened: !this.state.spinOpened,
                          spinData: this.props.spinsData.filter(
                            (e: any) =>
                              e.id ===
                              this.state.filter?.spins[0].spin_landscape
                          )[0],
                        },
                        () => {
                          this.props.handleOpenPropertiesSpin(
                            this.state.spinData
                          );
                        }
                      );
                    }}
                  >
                    <img src={"./UI/amenities/recorrido.svg"} alt="" />
                    <div>Spin</div>
                  </div>
                ) : (
                  <></>
                )}
                {this.state.filter.galleries &&
                this.state.filter.galleries.length > 0
                  ? this.state.filter.galleries.map(
                      (gallery: any, index: number) => (
                        <div
                          className="tooltip-gallery-individual-item"
                          key={"tooltip-gallery" + index}
                          onClick={() => {
                            this.props.handleamenitiesMenySelection(gallery);
                          }}
                        >
                          <img src={gallery.icon} alt="" />
                          <div>{gallery.name}</div>
                        </div>
                      )
                    )
                  : null}
                {/* {this.state.filter.galleries &&
                this.state.filter.galleries.length > 0 ? (
                  <div
                    className="tooltip-gallery-individual-item"
                    key={"tooltip-gallery"}
                    onClick={() => {
                      this.props.handleamenitiesMenySelection(
                        this.state.filter.galleries
                      );
                    }}
                  >
                    <img src={gallery_i} alt="" />
                    <div>Galería</div>
                  </div>
                ) : null} */}
              </div>
            </div>
            {this.props.isQuotation ? <hr></hr> : null}
            {this.props.isQuotation ? (
              <div className="tooltip-quotation">
                {this.props.quotationProperties.some(
                  (e: any) => e.id === this.state.filter.id
                ) ? (
                  <div
                    className="tooltip-quotation-individual-item-lista"
                    key={"tooltip-quotation-lista"}
                    style={{ backgroundColor: this.props.colors.main_buttons }}
                    onClick={() =>
                      this.props.handleRemovePropertyInQuotation(
                        this.state.filter
                      )
                    }
                  >
                    <div>En Lista</div>
                  </div>
                ) : this.props.quotationProperties.length < 6 ? (
                  <div
                    className="tooltip-quotation-individual-item"
                    key={"tooltip-quotation"}
                    onClick={() =>
                      this.props.handleSetPropertyInQuotation(this.state.filter)
                    }
                  >
                    <div>Agregar a cotización</div>
                  </div>
                ) : (
                  <div
                    className="tooltip-quotation-individual-item-limit"
                    style={{ color: this.props.colors.main_buttons }}
                  >
                    Tienes 5 Inmuebles seleccionados
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default PropertiesTooltip;
